"use strict";

var CivicColorBox = require("./colorbox-confirm-civic");
var FoodtruckColorBox = require("./colorbox-confirm-foodtruck");
var globals = require("globals");

module.exports = function (settings, okCallback, cancelCallback, closedCallback) {
  if (globals.siteId === 5) {
    return new FoodtruckColorBox(settings, okCallback, cancelCallback, closedCallback);
  }
  settings.siteId = globals.siteId;
  return new CivicColorBox(settings, okCallback, cancelCallback, closedCallback);
};